import { toast } from "react-hot-toast";
import { actionType } from "../utils/helpers/generalHelper";
import * as StudentConstants from "../constants/student.constant";
import StudentService from "../services/student.service";
import ErrorHelper from "../utils/helpers/errorHelper";
import cookieHelper from "../utils/helpers/cookieHelper";
import { configs } from "../utils/helpers/constants";
import { getProfile } from "./profile.action";

export const fetchAllStudent = (pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.FETCH_ALL_STUDENT_REQUEST));
    const data = await StudentService.fetchAllStudent(pageAble);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    dispatch(actionType(StudentConstants.FETCH_ALL_STUDENT_SUCCESS, userData));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.FETCH_ALL_STUDENT_FAILURE));
    toast.error(message);
  }
};

export const fetchByGraduationYear = (value, pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.FETCH_STUDENT_YEAR_REQUEST));
    const data = await StudentService.fetchByGraduationYear(value, pageAble);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    dispatch(actionType(StudentConstants.FETCH_STUDENT_YEAR_SUCCESS, userData));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.FETCH_STUDENT_YEAR_FAILURE));
    toast.error(message);
  }
};

export const fetchByProgram = (value, pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.FETCH_STUDENT_PROGRAM_REQUEST));
    const data = await StudentService.fetchByProgram(value, pageAble);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    dispatch(
      actionType(StudentConstants.FETCH_STUDENT_PROGRAM_SUCCESS, userData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.FETCH_STUDENT_PROGRAM_FAILURE));
    toast.error(message);
  }
};

export const fetchPeopleYouMayKnow = (pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.FETCH_PEOPLE_YOU_MAY_KNOW_REQUEST));
    const data = await StudentService.fetchPeopleYouMayKnow(pageAble);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    dispatch(
      actionType(StudentConstants.FETCH_PEOPLE_YOU_MAY_KNOW_SUCCESS, userData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.FETCH_PEOPLE_YOU_MAY_KNOW_FAILURE));
    toast.error(message);
  }
};

export const activateAccount =
  (payload, matricNumber, navigate) => async (dispatch) => {
    try {
      dispatch(actionType(StudentConstants.ACTIVATE_USER_REQUEST));
      const data = await StudentService.activateAccount(payload, matricNumber);
      //status code should be changed from the backend
      if (data.status === 400) {
        dispatch(
          actionType(
            StudentConstants.ACTIVATE_PAYMENT_MODAL,
            data.data.errors[0]
          )
        );
      }
      if (data === undefined || data.status !== 200) {
        throw data;
      }
      const userData = data;
      dispatch(actionType(StudentConstants.ACTIVATE_USER_SUCCESS, userData));
      await dispatch(getProfile());
      navigate();
    } catch (error) {
      console.error(error.response);
      // console.error(error.response.data.status);
      let message = ErrorHelper.getApiErrorMessage(error);
      dispatch(actionType(StudentConstants.ACTIVATE_USER_FAILURE));
      toast.error(message);
    }
  };

export const fetchUserProfile = (userId) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.FETCH_STUDENT_PROFILE_REQUEST));
    const data = await StudentService.fetchUserProfile(userId);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    dispatch(
      actionType(StudentConstants.FETCH_STUDENT_PROFILE_SUCCESS, userData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.FETCH_STUDENT_PROFILE_FAILURE));
    toast.error(message);
  }
};

export const fetchStudentDetails = (matricNumber, link) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.FETCH_STUDENT_INFO_REQUEST));
    const data = await StudentService.fetchStudentInfo(matricNumber);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    const accountStatus = userData["accountStatus"];
    await cookieHelper.set(
      configs.USER_ACTIVATED_STATUS,
      accountStatus,
      configs.COOKIE_EXPIRY_PERIOD
    );
    dispatch(actionType(StudentConstants.FETCH_STUDENT_INFO_SUCCESS, userData));
    link();
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.FETCH_STUDENT_INFO_FAILURE));
    toast.error(message);
  }
};

export const fetchUserDetails = (matricNumber) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.FETCH_STUDENT_INFO_REQUEST));
    const data = await StudentService.fetchStudentInfo(matricNumber);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    const accountStatus = userData["accountStatus"];
    await cookieHelper.set(
      configs.USER_ACTIVATED_STATUS,
      accountStatus,
      configs.COOKIE_EXPIRY_PERIOD
    );
    dispatch(actionType(StudentConstants.FETCH_STUDENT_INFO_SUCCESS, userData));
  } catch (error) {
    console.error(error);
    dispatch(actionType(StudentConstants.FETCH_STUDENT_INFO_FAILURE));
  }
};

export const uploadStudentFile = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.UPLOAD_STUDENT_FILE_REQUEST));
    const data = await StudentService.uploadStudentFile(payload);
    console.error("data ", data);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    console.error("responseData ", responseData);
    dispatch(
      actionType(StudentConstants.UPLOAD_STUDENT_FILE_SUCCESS, responseData)
    );
    toast.success(responseData.message);
  } catch (error) {
    console.error(error);
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.UPLOAD_STUDENT_FILE_FAILURE));
    toast.error(message);
  }
};

export const deleteStudent = (payload) => async (dispatch) => {
  const { id, name } = payload;
  try {
    dispatch(
      actionType(StudentConstants.DELETE_STUDENT_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await StudentService.delete(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(StudentConstants.DELETE_STUDENT_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`${name} deleted successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.DELETE_STUDENT_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};

export const assignStudentRole = (payload) => async (dispatch) => {
  const { id, name, role } = payload;
  try {
    dispatch(
      actionType(StudentConstants.ASSIGN_ROLE_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await StudentService.assignRole(id, role);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(StudentConstants.ASSIGN_ROLE_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`Role assigned to ${name} successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.ASSIGN_ROLE_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};

export const assignStudentOffice = (id, payload) => async (dispatch) => {
  try {
    dispatch(
      actionType(StudentConstants.ASSIGN_OFFICE_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await StudentService.assignOffice(id, payload);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(StudentConstants.ASSIGN_OFFICE_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`Office assigned successfully.`);
    window.location.reload();
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.ASSIGN_OFFICE_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};

export const fetchAllMemberDirectory = (pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.FETCH_ALL_MEMBER_REQUEST));
    const data = await StudentService.fetchMemberDirectory(pageAble);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const userData = data.data;
    dispatch(actionType(StudentConstants.FETCH_ALL_MEMBER_SUCCESS, userData));
  } catch (error) {
    console.error(error);
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.FETCH_ALL_MEMBER_FAILURE));
    toast.error(message);
  }
};

export const retractStudentOffice = (payload) => async (dispatch) => {
  const { id } = payload;
  try {
    dispatch(
      actionType(StudentConstants.RETRACT_STUDENT_OFFICE_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await StudentService.retractOffice(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(StudentConstants.RETRACT_STUDENT_OFFICE_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`Office retracted successfully.`);
    window.location.reload();
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.RETRACT_STUDENT_OFFICE_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};

export const fetchMembersByLastName = (value, pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(StudentConstants.FETCH_STUDENT_LASTNAME_REQUEST));
    const data = await StudentService.fetchByLastName(value, pageAble);
    console.log("trespnse ", data);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    const payload = data.data;
    dispatch(actionType(StudentConstants.FETCH_STUDENT_LASTNAME_SUCCESS, payload));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(StudentConstants.FETCH_STUDENT_LASTNAME_FAILURE));
    toast.error(message);
  }
};
